import React, { useState } from 'react';
import { Heart, ArrowRight } from 'lucide-react';
import SponsorshipApplyCard from '../components/SponsorshipApplyCard';
import DonationModal from '../components/DonationModal';
import ImpactContributionGraph from '../components/ImpactContributionGraph';

const FOUNDATION_URL = 'https://ironlimb.com';

const Impact = () => {
  const [donateOpen, setDonateOpen] = useState(false);
  return (
    <div className="bg-transparent text-enf-text-primary min-h-screen pt-20 pb-16">
      {/* Hero */}
      <div className="relative overflow-hidden mb-12">
        <div className="absolute inset-0 bg-gradient-to-br from-enf-surface-special via-enf-border-special/30 to-black" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(220,38,38,0.15),transparent_60%)]" />
        <div className="relative max-w-5xl mx-auto px-6 py-16">
          <h1 className="font-display text-6xl md:text-8xl tracking-wide leading-none mb-4">Impact Dashboard.</h1>
          <p className="enf-impact-hero-subtext text-enf-text-secondary text-lg max-w-2xl leading-relaxed mb-5">
            Every rep, every ride, every round — converted into measurable support for the IronLimb Foundation. See exactly how your contribution translates to dollars raised for Phantom Limb Syndrome research and amputee community programs.
          </p>
          <a href={FOUNDATION_URL} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-enf-role-info hover:text-enf-text-primary text-sm font-semibold transition-colors">
            Learn about the IronLimb Foundation <ArrowRight className="w-3.5 h-3.5" />
          </a>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6">
        {/* Live contribution tracker (IMP-1) */}
        <ImpactContributionGraph />

        {/* One-time donation to IronLimb — direct contribution path, surfaced
            right under the tracker so lifetime-tier users (founders/heros/comp)
            who never see /pricing still have a way to give. */}
        <div className="relative overflow-hidden rounded-xl border border-enf-accent-fg/30 bg-gradient-to-br from-enf-surface-special via-enf-accent/10 to-enf-surface-deep">
          <div className="relative p-6 md:p-8 flex flex-col md:flex-row md:items-center md:justify-between gap-5">
            <div className="max-w-2xl">
              <div className="flex items-center gap-2 mb-2">
                <Heart className="w-4 h-4 text-enf-accent-fg" />
                <div className="text-xs uppercase tracking-[0.3em] font-semibold text-enf-accent-fg">Support IronLimb directly</div>
              </div>
              <h3 className="font-display text-2xl md:text-3xl tracking-wide leading-tight mb-2">One-time donation.</h3>
              <p className="text-sm text-enf-text-secondary leading-relaxed">
                Skip the subscription path. Send a one-time contribution that goes directly into IronLimb research, amputee sponsorship, or split between both — your choice of allocation.
              </p>
            </div>
            <button
              type="button"
              onClick={() => setDonateOpen(true)}
              data-testid="impact-donate-button"
              className="self-start md:self-auto inline-flex items-center gap-2 px-5 py-2.5 bg-enf-accent hover:bg-enf-accent-hover rounded-md text-sm font-semibold transition-colors whitespace-nowrap"
            >
              <Heart className="w-4 h-4" /> Donate now
            </button>
          </div>
        </div>

        <DonationModal open={donateOpen} onOpenChange={setDonateOpen} />

        {/* Sponsored Account application */}
        <div className="mt-10">
          <SponsorshipApplyCard />
        </div>
      </div>
    </div>
  );
};

export default Impact;
